import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { errorToast } from '../toast';

/**
 * Redirects to a fallback route with an error toast when an entity is not found.
 */
export const useRedirectIfNotFound = (notFound: boolean, path: string, message: string) => {
    const history = useHistory();

    useEffect(() => {
        if (notFound) {
            errorToast(message);
            history.replace(path);
        }
    }, [notFound, history, message, path]);
};
